import { render, staticRenderFns } from "./SpcmList.vue?vue&type=template&id=85fd821a&scoped=true"
import script from "./SpcmList.vue?vue&type=script&lang=js"
export * from "./SpcmList.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./SpcmList.vue?vue&type=style&index=1&id=85fd821a&prod&lang=css&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fd821a",
  null
  
)

export default component.exports